import React from 'react';

import { ColorToken } from '../../theme/tokens/color';
import { IconWrapper } from './styles';

export interface SocialIconProps {
  colour?: ColorToken;
  hoverColor?: ColorToken;
  size?: 'small' | 'large';
}

export const FacebookIcon = ({
  colour = 'socialIcon',
  hoverColor = 'socialIconHover',
  size
}: SocialIconProps) => (
  <IconWrapper colour={colour} hoverColor={hoverColor} size={size}>
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="socialIcon"
        d="M25.322 12.622C25.322 5.60979 19.6343 0 12.6999 0C5.76561 0 0 5.6877 0 12.622C0 18.933 4.59691 24.1532 10.6742 25.1661V16.284H7.47972V12.622H10.6742V9.81713C10.6742 6.62267 12.5441 4.90856 15.4269 4.90856C16.8294 4.90856 18.2318 5.1423 18.2318 5.1423V8.25885H16.6735C15.1153 8.25885 14.6478 9.27173 14.6478 10.2067V12.5441H18.1539L17.6085 16.2061H14.6478V25.0882C20.725 24.2312 25.322 19.0109 25.322 12.622Z"
        fill="white"
      />
      <defs>
        <clipPath>
          <rect width="25.322" height="25.1661" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </IconWrapper>
);

export const YouTubeIcon = ({
  colour = 'socialIcon',
  hoverColor = 'socialIconHover',
  size
}: SocialIconProps) => (
  <IconWrapper colour={colour} hoverColor={hoverColor} size={size}>
    <svg
      width="27"
      height="26"
      viewBox="0 0 27 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="socialIcon"
        d="M13.5667 0C16.9949 0 17.3844 0 18.7869 0.0779137C20.1114 0.155827 21.0464 0.389569 21.8255 0.701223C22.6826 1.01288 23.3838 1.48036 24.085 2.18158C24.7862 2.88281 25.2537 3.58403 25.5654 4.44108C25.877 5.22022 26.1108 6.15518 26.1887 7.47972C26.2666 8.80425 26.2666 9.27173 26.2666 12.6999C26.2666 16.1281 26.2666 16.5177 26.1887 17.9202C26.1108 19.2447 25.877 20.1797 25.5654 20.9588C25.2537 21.8158 24.7862 22.5171 24.085 23.2183C23.3838 23.9195 22.6826 24.387 21.8255 24.6986C21.0464 25.0103 20.1114 25.244 18.7869 25.322C17.4623 25.3999 16.9949 25.3999 13.5667 25.3999C10.1385 25.3999 9.74889 25.3999 8.34644 25.322C7.02191 25.244 6.08695 25.0103 5.30781 24.6986C4.45076 24.387 3.74953 23.9195 3.04831 23.2183C2.34709 22.5171 1.87961 21.8158 1.56795 20.9588C1.2563 20.1797 1.02255 19.2447 0.944641 17.9202C0.944641 16.4398 0.944641 15.9723 0.944641 12.622C0.944641 9.19382 0.944641 8.80425 1.02255 7.4018C1.10047 6.07727 1.33421 5.1423 1.64586 4.36317C1.95752 3.50612 2.425 2.80489 3.12622 2.10367C3.82745 1.40245 4.52867 0.934965 5.38572 0.62331C6.16486 0.311655 7.09982 0.0779137 8.42436 0C9.67098 0 10.1385 0 13.5667 0Z"
        fill="white"
      />
      <path
        d="M23.4617 7.55763C23.228 6.62266 22.5267 5.92144 21.5918 5.6877C19.9556 5.22022 13.4887 5.22021 13.4887 5.22021C13.4887 5.22021 7.02191 5.22022 5.38572 5.6877C4.52867 5.92144 3.82745 6.62266 3.51579 7.55763C3.04831 9.19381 3.04831 12.5441 3.04831 12.5441C3.04831 12.5441 3.04831 15.9723 3.51579 17.5306C3.74953 18.4655 4.45076 19.1668 5.38572 19.4005C7.02191 19.868 13.4887 19.868 13.4887 19.868C13.4887 19.868 19.9556 19.868 21.5918 19.4005C22.4488 19.1668 23.15 18.4655 23.4617 17.5306C23.9292 15.8944 23.9292 12.5441 23.9292 12.5441C23.9292 12.5441 23.8513 9.19381 23.4617 7.55763ZM11.3851 15.6607V9.50547L16.7611 12.622L11.3851 15.6607Z"
        fill="#1D252C"
      />
      <defs>
        <clipPath>
          <rect x="0.944641" width="25.1661" height="25.1661" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </IconWrapper>
);

export const YouTube20Icon = ({
  colour = 'socialIcon',
  hoverColor = 'socialIconHover',
  size
}: SocialIconProps) => (
  <IconWrapper colour={colour} hoverColor={hoverColor} size={size}>
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="socialIcon"
        d="M23.4627 2.55283C23.194 1.5317 22.388 0.765849 21.3134 0.510566C19.4328 3.04321e-07 12 0 12 0C12 0 4.56716 3.04321e-07 2.68657 0.510566C1.70149 0.765849 0.895522 1.5317 0.537313 2.55283C-1.06755e-07 4.33981 0 7.99886 0 7.99886C0 7.99886 -1.06755e-07 11.743 0.537313 13.4449C0.80597 14.466 1.61194 15.2319 2.68657 15.4872C4.56716 15.9977 12 15.9977 12 15.9977C12 15.9977 19.4328 15.9977 21.3134 15.4872C22.2985 15.2319 23.1045 14.466 23.4627 13.4449C24 11.6579 24 7.99886 24 7.99886C24 7.99886 23.9104 4.33981 23.4627 2.55283ZM9.58208 11.4026V4.68018L15.7612 8.08396L9.58208 11.4026Z"
        fill="white"
      />
    </svg>
  </IconWrapper>
);

export const TwitterIcon = ({
  colour = 'socialIcon',
  hoverColor = 'socialIconHover',
  size
}: SocialIconProps) => (
  <IconWrapper colour={colour} hoverColor={hoverColor} size={size}>
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="socialIcon"
        d="M13.5113 0C6.49904 0 0.889252 5.60979 0.889252 12.622C0.889252 19.6343 6.49904 25.244 13.5113 25.244C20.5235 25.244 26.1333 19.6343 26.1333 12.622C26.1333 5.60979 20.4456 0 13.5113 0ZM19.8223 10.2067C19.8223 10.3625 19.8223 10.4404 19.8223 10.5963C19.8223 14.5699 16.7836 19.2447 11.1739 19.2447C9.45976 19.2447 7.90149 18.7772 6.49904 17.9202C6.73278 17.9202 6.96652 17.9202 7.27818 17.9202C8.68062 17.9202 10.0052 17.4527 11.018 16.5956C9.6935 16.5956 8.60271 15.6607 8.21314 14.492C8.36897 14.492 8.60271 14.5699 8.75854 14.5699C9.07019 14.5699 9.30393 14.5699 9.53767 14.492C8.13523 14.1803 7.12235 12.9337 7.12235 11.4533C7.51192 11.6871 7.9794 11.8429 8.5248 11.8429C7.74566 11.2975 7.20026 10.3625 7.20026 9.34965C7.20026 8.80425 7.35609 8.25885 7.58983 7.79137C9.07019 9.6613 11.3297 10.83 13.8229 10.9858C13.745 10.7521 13.745 10.5184 13.745 10.2846C13.745 8.64842 15.0695 7.24598 16.7836 7.24598C17.6407 7.24598 18.4198 7.63554 18.9652 8.18094C19.6665 8.02511 20.2898 7.79137 20.9131 7.47972C20.6793 8.18094 20.2119 8.80425 19.5885 9.19382C20.2119 9.1159 20.7572 8.96008 21.3026 8.72634C20.9131 9.27173 20.3677 9.73921 19.8223 10.2067Z"
        fill="white"
      />
      <defs>
        <clipPath>
          <rect x="0.889252" width="25.1661" height="25.1661" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </IconWrapper>
);

export const Twitter20Icon = ({
  colour = 'socialIcon',
  hoverColor = 'socialIconHover',
  size
}: SocialIconProps) => (
  <IconWrapper colour={colour} hoverColor={hoverColor} size={size}>
    <svg
      width="19"
      height="17"
      viewBox="0 0 19 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="socialIcon"
        d="M17.1109 4.75425C17.1109 4.95303 17.1109 5.05241 17.1109 5.25119C17.1109 10.3199 13.2343 16.2832 6.07737 16.2832C3.89054 16.2832 1.90251 15.6868 0.113281 14.5936C0.411486 14.5936 0.70969 14.5936 1.1073 14.5936C2.89652 14.5936 4.58635 13.9973 5.87857 12.904C4.18874 12.904 2.79712 11.7114 2.30011 10.2205C2.49892 10.2205 2.79712 10.3199 2.99593 10.3199C3.39353 10.3199 3.69174 10.3199 3.98994 10.2205C2.20071 9.823 0.908494 8.2328 0.908494 6.34445C1.4055 6.64261 2.00191 6.84138 2.69772 6.84138C1.70371 6.14567 1.0079 4.95303 1.0079 3.66099C1.0079 2.96528 1.2067 2.26957 1.5049 1.67325C3.39353 4.05854 6.27617 5.54935 9.45702 5.74813C9.35762 5.44996 9.35762 5.1518 9.35762 4.85364C9.35762 2.76651 11.0474 0.977539 13.2343 0.977539C14.3277 0.977539 15.3217 1.47448 16.0175 2.17019C16.9121 1.97141 17.7073 1.67325 18.5026 1.2757C18.2044 2.17019 17.6079 2.96528 16.8127 3.46222C17.6079 3.36283 18.3038 3.16406 18.9996 2.8659C18.5026 3.56161 17.8067 4.15793 17.1109 4.75425Z"
        fill="#9AB5B8"
      />
    </svg>
  </IconWrapper>
);

export const InstagramIcon = ({
  colour = 'socialIcon',
  hoverColor = 'socialIconHover',
  size
}: SocialIconProps) => (
  <IconWrapper colour={colour} hoverColor={hoverColor} size={size}>
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="socialIcon"
        d="M13.4559 2.2595C16.8062 2.2595 17.1957 2.2595 18.5203 2.33741C19.7669 2.41533 20.3902 2.57115 20.8577 2.80489C21.481 3.03863 21.8706 3.27238 22.338 3.73986C22.8055 4.20734 23.0393 4.59691 23.273 5.22022C23.4288 5.6877 23.6626 6.31101 23.7405 7.55763C23.8184 8.88216 23.8184 9.27173 23.8184 12.622C23.8184 15.9723 23.8184 16.3619 23.7405 17.6864C23.6626 18.933 23.5068 19.5563 23.273 20.0238C23.0393 20.6471 22.8055 21.0367 22.338 21.5042C21.8706 21.9717 21.481 22.2054 20.8577 22.4391C20.3902 22.595 19.7669 22.8287 18.5203 22.9066C17.1957 22.9845 16.8062 22.9845 13.4559 22.9845C10.1056 22.9845 9.71603 22.9845 8.39149 22.9066C7.14487 22.8287 6.52156 22.6729 6.05408 22.4391C5.43077 22.2054 5.0412 21.9717 4.57372 21.5042C4.10624 21.0367 3.8725 20.6471 3.63876 20.0238C3.48293 19.5563 3.24919 18.933 3.17127 17.6864C3.09336 16.3619 3.09336 15.9723 3.09336 12.622C3.09336 9.27173 3.09336 8.88216 3.17127 7.55763C3.24919 6.31101 3.40501 5.6877 3.63876 5.22022C3.8725 4.59691 4.10624 4.20734 4.57372 3.73986C5.0412 3.27238 5.43077 3.03863 6.05408 2.80489C6.44365 2.57115 7.06696 2.41533 8.31358 2.33741C9.63811 2.2595 10.0277 2.2595 13.4559 2.2595ZM13.4559 0C10.0277 0 9.63811 0 8.23567 0.0779137C6.91113 0.155827 5.97617 0.311655 5.19703 0.62331C4.33998 0.934965 3.63876 1.40245 2.93753 2.10367C2.23631 2.80489 1.84674 3.50612 1.45717 4.36317C1.14552 5.1423 0.911776 6.07727 0.833862 7.4018C0.833862 8.72634 0.833862 9.19382 0.833862 12.622C0.833862 16.0502 0.833862 16.4398 0.911776 17.8422C0.98969 19.1668 1.22343 20.1017 1.53509 20.8809C1.84674 21.7379 2.31422 22.4391 3.01545 23.1404C3.71667 23.8416 4.41789 24.3091 5.27494 24.6207C6.05408 24.9324 6.98905 25.1661 8.31358 25.244C9.63811 25.322 10.1056 25.322 13.5338 25.322C16.962 25.322 17.3516 25.322 18.754 25.244C20.0786 25.1661 21.0135 24.9324 21.7927 24.6207C22.6497 24.3091 23.3509 23.8416 24.0521 23.1404C24.7534 22.4391 25.2209 21.7379 25.5325 20.8809C25.8442 20.1017 26.0779 19.1668 26.1558 17.8422C26.2337 16.5177 26.2337 16.0502 26.2337 12.622C26.2337 9.19382 26.2337 8.80425 26.1558 7.4018C26.0779 6.07727 25.8442 5.1423 25.5325 4.36317C25.2209 3.50612 24.7534 2.80489 24.0521 2.10367C23.3509 1.40245 22.6497 0.934965 21.7927 0.62331C21.0135 0.311655 20.0786 0.0779137 18.754 0C17.2737 0 16.8062 0 13.4559 0Z"
        fill="white"
      />
      <path
        className="socialIcon"
        d="M13.4559 6.15527C9.87186 6.15527 6.98905 9.03808 6.98905 12.6221C6.98905 16.2061 9.87186 19.0889 13.4559 19.0889C17.0399 19.0889 19.9227 16.2061 19.9227 12.6221C19.9227 9.03808 16.962 6.15527 13.4559 6.15527ZM13.4559 16.7515C11.1185 16.7515 9.24855 14.8816 9.24855 12.5442C9.24855 10.2068 11.1185 8.33686 13.4559 8.33686C15.7933 8.33686 17.6632 10.2068 17.6632 12.5442C17.5853 14.8816 15.7154 16.7515 13.4559 16.7515Z"
        fill="white"
      />
      <path
        className="socialIcon"
        d="M20.1565 7.32376C20.974 7.32376 21.6368 6.66098 21.6368 5.8434C21.6368 5.02582 20.974 4.36304 20.1565 4.36304C19.3389 4.36304 18.6761 5.02582 18.6761 5.8434C18.6761 6.66098 19.3389 7.32376 20.1565 7.32376Z"
        fill="white"
      />
      <defs>
        <clipPath>
          <rect x="0.833862" width="25.1661" height="25.1661" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </IconWrapper>
);
